// @ts-nocheck
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";

import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import RevenueStats from "./RevenueStats";
import GuestsStats from "./GuestsStats";
import StatsPeriodFilters from "./StatsPeriodFilters";
import useStats from "./hooks/useStats";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const StatsPage = () => {
  const { t } = useTranslation("dashboard");
  const [activeTab, setActiveTab] = useState("revenue");
  const [appliedPeriod, setAppliedPeriod] = useState(() => ({
    from: moment().subtract(6, "months").startOf("month").format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
  }));
  const stats = useStats(activeTab, appliedPeriod.from, appliedPeriod.to);

  return (
    <>
      <h1 className="mb-3">Statistiken</h1>
      <StatsPeriodFilters
        {...appliedPeriod}
        onApply={setAppliedPeriod}
        loading={stats === null}
      />
      <Tabs
        id="stats-tabs"
        activeKey={activeTab}
        onSelect={(tab) => setActiveTab(tab)}
        className="mb-4"
      >
        <Tab eventKey="revenue" title={t("stats.tabs.revenue")}>
          {activeTab === "revenue" && <RevenueStats stats={stats} />}
        </Tab>
        <Tab eventKey="guests" title={t("stats.tabs.guests")}>
          {activeTab === "guests" && <GuestsStats stats={stats} />}
        </Tab>
      </Tabs>
    </>
  );
};

export default StatsPage;
